<template>
  <div class="wrapper" @mouseup="ponitUp">
    <!-- 导航栏和播放器 -->
    <div class="wrapper-left" :class="foldStatus == 0 ? 'expand' : 'put-away'">
      <div class="header flex-a-c" v-show="!fullscreen">
        <!-- <div class="back color2 flex-a-c cursor-p">
          <i class="iconfont icon-xiangzuo"></i>
          <span class="ml5" @click="beforeunloadFn">
            模拟页面关闭或刷新
          </span>
        </div> -->
        <div class="course-name color3 fs18">
          {{ video_title || '' }}
        </div>
        <div>
          <div class="color2 fs14">
            {{ playData.course_uv }}人学习过
          </div>
          <div class="color1 fs12">
            {{ playData.course_pv }}次学习热度
          </div>
        </div>
      </div>

      <!-- 播放器 -->
      <div class="player-box" @mouseleave="isInPlayerBox = 0" @mousemove="isInPlayerBox = 1" v-show="!videoLoading">
        <!-- 展开折叠 -->
        <div class="fold-box flex-aj-c cursor-p" @click="foldClick" v-if="playData && playData.attribute == '2'">
          <i class="iconfont  color3" :class="foldStatus == 0 ? 'icon-xiangzuo' : 'icon-youbian'"></i>
        </div>
        <div class="video-player-wrapper">
          <img v-show="!playFlag" src="../../../assets/img/big-play.png" class="big-play" @click="playVideo">
          <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
            :options="playerOptions" @play="onPlayerPlay($event)" @pause="onPlayerPause($event)"
            @ended="onPlayerEnded($event)" @waiting="onPlayerWaiting($event)" @playing="onPlayerPlaying($event)"
            @loadeddata="onPlayerLoadeddata($event)" @timeupdate="onPlayerTimeupdate($event)"
            @canplay="onPlayerCanplay($event)" @canplaythrough="onPlayerCanplaythrough($event)"
            @statechanged="playerStateChanged($event)" @ready="playerReadied">
          </video-player>

          <!-- 进度条 -->
          <div class="video-control-bar flex-a-c flex-j-sb" v-show="controlBarShow">
            <div class="progress-box cursor-p" @click.stop="barClick" ref="progress">
              <div class="progress-green cursor-p" :style="styleObj" :class="progressDrag ? '' : 'trw'">
                <div class="point cursor-p" :class="progressDrag ? 'point-big' : ''" @click.stop=""
                  @mousedown.stop="ponitDown" @mouseup.stop="ponitUp"></div>
              </div>
            </div>
            <div class="flex-a-c">
              <img src="./img/up.png" class="icon" @click="toggle(-1)" v-show="course_info_index != 0">
              <img src="./img/bf.png" v-show="!playFlag" class="icon" @click="playVideo">
              <i v-show="playFlag" class="icon iconfont icon-zanting color3" @click="pauseVideo"></i>
              <img src="./img/down.png" class="icon" @click="toggle(1)" v-show="isShowNext">
              <div class="fs16 color3">
                {{ currentTime }} / {{ duration }}
              </div>
            </div>

            <div class="flex-a-c">
              <img :src="volumeImg" @click="volumeClick" class="icon" alt="">
              <div class="fs16 color3 cursor-p playbackRate-box" @mouseover="playbackRateShowFlag = true"
                @mouseleave="playbackRateShowFlag = false">
                <div class="list" v-show="playbackRateShowFlag">
                  <div class="item " :class="index == playbackRateIndex ? 'active' : ''"
                    v-for="(el, index) in playbackRatesList" :key="el" @click="multiplePlayClick(el, index)"
                    @mouseleave="playbackRateShowFlag = false">
                    {{ el }}x
                  </div>
                  <div class="item"></div>
                </div>
                <div>
                  {{ playbackRatesList[playbackRateIndex] }}x
                </div>
              </div>
              <div class="fs16 color3 mr44 cursor-p">
                <!-- <div>收看时长： {{ stayObj.study_time }}s</div> -->
              </div>
              <img src="./img/qp.png" class="icon " alt="" @click="screen">
            </div>
          </div>
        </div>
      </div>
      <div class="player-box player-box-waiting flex-aj-c" v-show="videoLoading">
        <Lottie styleObj="width:200px" path="./loading.json"></Lottie>
      </div>
    </div>


    <!-- 右侧章节 -->
    <div class="chapter-box animate__animated"
      :class="foldStatus == 0 ? 'chapter-hide' : 'chapter-show  animate__fadeInRight'"
      v-if="playData && playData.attribute == '2'">
      <div class="title color3 fs20">
        {{ playData.title }}
      </div>
      <div class="list-outer-container">
        <div class="list">
          <div class="item color3 fs14 flex-a-c"
            :class="[course_info_index == index ? 'active' : '', item.is_watch > 0 ? 'color797878' : '']"
            v-for="(item, index) in playData.course_info" :key="item.id" @click="itemClick(item, index)">
            <div class="flex-a-c " @mouseenter="item.popoverVisible = true" @mouseleave="item.popoverVisible = false">
              {{ index + 1 }}.&nbsp;&nbsp;&nbsp;
              <i class="iconfont " :class="item.is_watch > 0 ? 'icon-wancheng' : 'icon-w_shipin'"></i>
              <el-popover placement="left" width="200" v-model="item.popoverVisible"
                :content="index + 1 + '：' + item.video_title">
                <div class="video_title" slot="reference">
                  {{ item.video_title }}
                </div>
              </el-popover>
            </div>
            <div class="flex-a-c">
              <Lottie styleObj="width:20px" class="playing" ref="LottieLoadingplay" v-if="course_info_index == index"
                path="./player.json" idattr="player">
              </Lottie>
              {{ item.video_duration | filterDurtion }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="25%" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false">
      <span>系统监测到你长时间没有操作页面，请确认是否继续学习！</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "animate.css"
import $ from 'jquery'
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
import Lottie from "@/components/Lottie";
import 'vue-video-player/src/custom-theme.css'
import moment from "moment";
import _ from 'lodash'
import dayjs from 'dayjs'
import img1 from './img/yinlianggao.png'
import img2 from './img/yinliangdi.png'
import img3 from './img/jinyin.png'
export default {
  components: {
    videoPlayer,
    Lottie
  },
  name: 'count_center_player',
  data() {
    return {
      that: this,
      debug_type: '', // 是否开启调试 200 是
      dialogVisible: false,
      videoLoading: true,  // 加载
      itemClickFlag: false, // 是否点击了章节进行切换
      userinfo: {},
      isInPlayerBox: 1, // 光标是否在播放器内
      controlBarShow: true, // 是否显示控制条
      video_title: '',
      movetimer: null, // 监听鼠标是否移动的防抖
      autoNextTimer: null, // 自动播放下一集
      mouseMoveFlag: true,
      mouseMoveLastTime: new Date().getTime(), // 鼠标移动的最后时间，方便计算5分钟内鼠标是否移动
      course_id: '', // 课程id
      today: '', // 今天日期
      video_id: "", // 视频资源id
      play_type: 1, // 默认1 需要上报 2 不需要上报
      playData: {},  // 播放数据
      course_info_index: -1, // 章节的索引
      leaveVisbility: false, // 是否离开此窗口
      progressDrag: false, // 是否拖拽
      fullscreen: false,  // 是否全屏
      playFlag: false,  // 是否播放
      mutedFlag: false,  // 是否静音
      volumeType: 1, // 1正常 2 声音小 3 静音
      playbackRate: '1', // 倍数
      playbackRateIndex: 1, // 倍数索引
      playbackRateShowFlag: false,  //是否显示倍数
      playbackRatesList: [0.7, 1.0, 1.5, 2.0], //播放速度
      foldStatus: 0, //0 收起 1 展开
      timer: null,  // 观看时间定时器
      progressChangeTimer: null,
      currentTime: '00:00:00',//当前播放时长
      currentTimeNumber: 0, // 当时播放时长数字
      playtimes: "", //视频观看起点
      duration: '00:00:00',//总时长
      canClickControlBar: false, // 是否可以操作进度条
      staytime: 0,
      stayObj: {// 页面停留时间
        study_time: 0,
        date: ""
      },
      durationNumber: 0, // 总时间数字
      styleObj: {    // 播放进度条
        width: "0%"
      },
      playerOptions: {   // vue-video-player 配置参数
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "application/x-mpegURL",
            src: ''
          },
        ],
        poster: '', //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
      }
    }
  },
  watch: {
    // 监听停留事件
    staytime(val) {
      // 停留时间60s上报一次
      if (val != 0 && val % 20 == 0 && this.play_type != 2) {
        this.pageStayReport()
      }
      // 监听鼠标五分钟内是否有活动轨迹，如果没有暂停视频
      if (this.mouseMoveFlag) {
        const nowtime = new Date().getTime()
        const difference_time = Math.floor((nowtime - this.mouseMoveLastTime) / 1000)
        if (difference_time > 300 && this.playFlag) {
          this.mouseMoveFlag = false
          this.pauseVideo() // 暂停视频
          this.dialogVisible = true
        }
      }

      // 如果光标在播放器内并且5s内没有移动隐藏控制条
      if (this.controlBarShow) {
        const nowtime = new Date().getTime()
        const difference_time = Math.floor((nowtime - this.mouseMoveLastTime) / 1000)
        if (difference_time > 5) {
          this.controlBarShow = false
        }
      }
    },
    // 监听鼠标是否在播放器内
    isInPlayerBox(newVal) {
      this.controlBarShow = newVal == 1 ? true : false
    },
    // 监听是否播放中
    playFlag(val) {
      if (val) {
        // 计算总学习时长
        if (this.play_type != 2) {
          this.timer = setInterval(() => {
            this.stayObj.study_time++
          }, 1000)
        }
        // 重置鼠标最后移动时间
        this.mouseMoveLastTime = new Date().getTime()
      } else {
        clearInterval(this.timer)
      }
    }
  },

  created() {
    this.userinfo = JSON.parse(localStorage.getItem('user_info'))
    this.course_id = this.$route.params.course_id
    this.debug_type = this.$route.params.debug
    this.play_type = this.$route.params.type // 2 表示不需要上报
  },
  filters: {
    filterDurtion(val) {
      let time = ''
      if (val <= 60) {
        time = `${val}秒`
      } else if (val > 60 && val <= 3600) {
        time = moment.utc(val * 1000).format("mm分ss秒")
      } else {
        time = moment.utc(val * 1000).format("HH时mm分ss秒")
      }
      return time
    }
  },

  computed: {
    isShowNext() {
      if (this.playData && Array.isArray(this.playData.course_info) && this.playData.course_info.length > 0) {
        return this.course_info_index != this.playData.course_info.length - 1
      } else {
        return false
      }
    },
    volumeImg() {
      let icon = ''
      if (this.volumeType == 1) {
        icon = img1
      } else if (this.volumeType == 2) {
        icon = img2
      } else if (this.volumeType == 3) {
        icon = img3
      }
      return icon
    }

  },

  mounted() {
    // 禁用右键
    this.disabledOncontextmenu()
    // 获取播放列表
    this.fetchData()
    // 页面停留定时器
    this.pagestaytimerFun()
    // 监听页面有没有被刷新
    window.addEventListener('beforeunload', this.beforeunloadFn)
    // 监听键盘按键全屏
    window.addEventListener('fullscreenchange', this.listenerfullscreenchange)
    // 监听鼠标移动事件，五分钟内没有移动暂停视频
    window.addEventListener('mousemove', this.listenermousemove)
    // 监听离开进入窗口
    window.addEventListener("visibilitychange", this.visibilitychangeFun);
    // 监听键盘事件
    window.addEventListener("keyup", this.listenerkeyup);
  },

  beforeDestroy() {
    window.removeEventListener("visibilitychange", this.visibilitychangeFun);
    window.removeEventListener('beforeunload', this.beforeunloadFn)
    window.removeEventListener('fullscreenchange', this.listenerfullscreenchange)
    window.removeEventListener('mousemove', this.listenermousemove)
    window.removeEventListener("keyup", this.listenerkeyup);
    clearInterval(this.pagestaytimer)
    clearInterval(this.timer)
    document.getElementById('app').style.background = '#f7f7f7'
  },
  methods: {
    init() {
      this.storeageId = `id_${this.userinfo.id}_${this.course_id}_${this.video_id}`
      this.today = dayjs(new Date().getTime()).format('YYYY-MM-DD');
      localStorage.setItem('storeageId', this.storeageId)
      localStorage.setItem('today', this.today)
      this.stayObj.date = this.today
      // 只有初次进来的时候才这里，点击章节的时候不走这里
      if (!this.itemClickFlag) {
        this.pageStayReport(1)
      }
    },
    disabledOncontextmenu() {
      document.oncontextmenu = function () {
        return false;
      }
    },
    dialogConfirm() {
      this.playVideo()
      this.dialogVisible = false
    },
    // 监听鼠标移动
    listenermousemove(el) {
      if (this.movetimer) {
        clearTimeout(this.movetimer)
      }
      // 光标在播放器内移动的时候展示滚动条
      if (this.isInPlayerBox == 1 && this.controlBarShow == false) {
        this.controlBarShow = true
      }
      this.movetimer = setTimeout(() => {
        // 提示弹窗弹出的时候不算
        if (!this.dialogVisible) {
          this.mouseMoveLastTime = new Date().getTime()
          this.mouseMoveFlag = true
        }
      }, 300)
    },
    // 监听键盘全屏
    listenerfullscreenchange(e) {
      this.fullscreen = !this.fullscreen
    },
    // 监听键盘事件
    listenerkeyup(e) {
      if (!this.canClickControlBar) return
      if (e.code == 'ArrowRight' || e.code == 'ArrowLeft') {
        this.controlBarShow = true
        this.mouseMoveLastTime = new Date().getTime()
        this.mouseMoveFlag = true
        // 快进  快退
        this.pauseVideo()
        let fastTime = 0

        if (e.code == 'ArrowRight') {
          fastTime = Number(this.currentTimeNumber) + 10 >= this.durationNumber ? this.durationNumber : Number(this.currentTimeNumber) + 10

        } else {
          fastTime = Number(this.currentTimeNumber) - 10 <= 0 ? 0 : Number(this.currentTimeNumber) - 10
        }

        this.calcprogressBar(fastTime)
        this.currentTimeNumber = fastTime
        this.playVideo()
      }
    },
    // 监听页面刷新或者是关闭
    beforeunloadFn(el) {
      // 如果了对象里面有temp_storeageId和temp_stayObj参数说明是没有上报成功，需要对齐进行缓存处理
      if (this.play_type != '2') {
        let storeageId;
        if (el.temp_storeageId) {
          storeageId = el.temp_storeageId
        } else {
          storeageId = localStorage.getItem('storeageId')
        }
        const today = localStorage.getItem('today')

        let data = this.getLocalStorage(storeageId) || []
        if (el.temp_stayObj && el.temp_stayObj.study_time > 1) {
          el.temp_stayObj.date = today
          data.push(el.temp_stayObj)
        } else if (this.stayObj.study_time > 1 && !el.temp_stayObj) {
          this.stayObj.date = today
          data.push(this.stayObj)
        }
        if (data.length > 0) {
          localStorage.setItem(storeageId, JSON.stringify(data))
        }
        this.staytime = 0
        this.stayObj.study_time = 0
      }
    },

    // 计算页面停留时间
    pagestaytimerFun() {
      if (this.play_type != '2') {
        this.pagestaytimer = setInterval(() => {
          this.staytime++
        }, 1000)
      }
    },

    /**
     * 学习时间上报逻辑：
     * 1.从进入页面开始每隔60s上报一次；如果离开当前窗口暂停计时；
     * 2.刷新页面会上报一次，主要逻辑是当页面刷新或者是关闭的时候会走【beforeunloadFn】函数，对当前的观看数据进行缓存，刷新之后会重新执行页面的逻辑，获取到视频的id之后会触发首次上报，把之前的缓存数据都上报一次；上报完成清楚缓存，上报失败，把当前的数据写入缓存，如果是后端写入失败，把返回的数据写入缓存
     * 
     */
    async pageStayReport(type) {
      if (this.play_type == 2) return  // 预览不进行上报
      /**
       * 页面进来先去获取是否有之前的缓存，有的话进行上报并删除
       */
      // 切换章节点的数据
      const temp_storeageId = _.cloneDeep(this.storeageId)
      let temp_stayObj = _.cloneDeep(this.stayObj)
      let data = this.getLocalStorage(this.storeageId) || []
      let data_arr = _.cloneDeep(data)
      // this.staytime = 0
      // 表示从第二次以后的上报，第一次上报直接读取缓存
      if (type != 1 && temp_stayObj.study_time > 1 && this.video_id) {
        data_arr.unshift(temp_stayObj)
      }
      if (this.debug_type == 200) {
        this.$message.success(JSON.stringify(data_arr))
      }


      if (data_arr.length > 0) {
        this.stayObj.study_time = 0
        data_arr.forEach(el => {
          el.course_id = this.course_id
          el.video_id = this.video_id
          el.date = el.date ? el.date : this.today
        });
        const [err, res] = await this.$http.post("study/report", {
          data: data_arr
        });

        if (err) {
          this.beforeunloadFn({ temp_storeageId, temp_stayObj })
          return;
        }
        if (Array.isArray(res.list) && res.list.length > 0) {
          localStorage.setItem(temp_storeageId, JSON.stringify(res.list))
        } else {
          localStorage.removeItem(temp_storeageId)
        }
      }
    },


    visibilitychangeFun() {
      if (document.visibilityState == "hidden") {
        //切离该页面时执行
        this.leaveVisbility = true
        // clearInterval(this.pagestaytimer)
        this.pauseVideo()
      } else if (document.visibilityState == "visible") {
        //切换到该页面时执行
        if (this.leaveVisbility) {
          this.leaveVisbility = false
          // this.pagestaytimerFun()
          if (this.$route.path == '/count_center/player' && this.durationNumber > 0) {
            this.$message.warning('系统监测到你已切换出当前页面，课程暂停播放！')
          }
        }
      }
    },

    back() {
      this.$router.back()
    },

    // 章节菜单展开折叠
    foldClick() {
      this.foldStatus = this.foldStatus == 0 ? 1 : 0
    },

    // 章节点击
    itemClick(item, index) {
      // 防止重复点击
      if (this.course_info_index == index) return
      this.playerOptions.poster = ''
      this.canClickControlBar = false // 是否可以操作进度条
      clearTimeout(this.autoNextTimer)
      this.reloadControl()
      if (this.play_type != 2) {
        // 点击切换的时候将上个课程的学习时间进行上报
        this.itemClickFlag = true
        this.pageStayReport()
        this.getPlayUrl(item, true)
      } else {
        this.videoLoading = true
        this.getPreviewUrl(item, index)
      }

    },
    // 重置进度条
    reloadControl() {
      this.durationNumber = 0
      this.currentTimeNumber = 0
      this.currentTime = '00:00:00'
      this.duration = '00:00:00'
      this.$refs.videoPlayer.player.currentTime(this.currentTimeNumber) // 设置播放时间
      this.styleObj.width = `0%`
    },
    //接口获取的视频观看起点
    async fetchData() {
      let httpurl = this.play_type == 2 ? 'course/play' : 'home/play'
      const [err, res] = await this.$http.post(httpurl, {
        course_id: this.course_id
      });
      if (err) {
        this.videoLoading = false
        return;
      }
      if (this.play_type == 2) {
        this.playerOptions.poster = res.list ? process.env.VUE_APP_URL + res.list.course_cover_url : ''
      } else {
        this.playerOptions.poster = res.list ? res.list.course_cover_url : ''
      }
      // 给每个章节标题添加是否显示完整标题
      if (res.list && res.list.course_info) {
        for (const i of res.list.course_info) {
          i.popoverVisible = false
        }
      }

      this.playData = res.list

      if (res.list.attribute == '2') {
        this.foldStatus = 1
      } else {
        this.foldStatus = 0
      }
      const { course_info } = res.list ? res.list : { course_info: [] }
      if (this.play_type != 2) {
        // 获取播放资源
        if (course_info && course_info.length > 0) {
          this.getPlayUrl(course_info[0])
        } else {
          this.videoLoading = false
        }
      } else {
        // 预览视频
        this.videoLoading = false
        if (course_info && course_info.length > 0) {
          this.getPreviewUrl(course_info[0], 0)
        }
      }
    },

    // 获取预览资源
    getPreviewUrl(item, index) {
      // 初始化播放时间
      this.currentTimeNumber = 0
      this.currentTime = '00:00:00'
      this.videoLoading = false
      setTimeout(() => {
        this.playVideo()
      }, 200)
      this.course_info_index = index
      let type = item.video_url.split('.').pop()
      this.playerOptions.sources[0].type = `video/${type ? type : 'mp4'}`
      this.playerOptions.sources[0].src = process.env.VUE_APP_URL + item.video_url
      this.video_title = this.playData.course_info[index].video_title
    },

    /**
     * 获取播放资源
     * 
     * 这里有几种情况需要注意下
     * 1、初次进来的时候获取当第一个章节的video_id 放到URL链接上，这一步操作是为了防止刷新的时候丢id
     * 2.如果是链接有video_id 说明是刷新，读取URL里面的id就可以了
     * 3.isclick表示列表点击切换学习视频，需要重置URL里面的video_id
     */
    async getPlayUrl(item, isclick = false) {
      this.videoLoading = true
      this.playerOptions.sources[0].src = ''
      this.pauseVideo()
      if (!this.$route.params.video_id || isclick) {
        this.$router.replace(`/count_center/player/${item.course_id}/${this.play_type || 1}/${item.id}`).catch(err => { err });
      }
      const [err, res] = await this.$http.post("play/url", {
        course_id: item.course_id,
        video_id: Number(this.$route.params.video_id)
      });
      this.videoLoading = false
      if (err) {
        return this.course_info_index = -1
      }
      const idx = this.playData.course_info.findIndex(el => el.id == this.$route.params.video_id)
      this.video_id = Number(this.$route.params.video_id)
      // 'https://yunqivedio.alicdn.com/2017yq/v2/0x0/96d79d3f5400514a6883869399708e11/96d79d3f5400514a6883869399708e11.m3u8'
      this.playerOptions.sources[0].src = res.url
      // 初始化播放时间
      this.currentTimeNumber = 0
      this.currentTime = '00:00:00'
      setTimeout(() => {
        this.playVideo()
      }, 200)
      this.course_info_index = idx  // 当前章节的索引
      this.video_title = this.playData.course_info[idx].video_title

      this.init()
    },

    // 获取缓存数据，此操作仅限于视频播放的缓存数据
    getLocalStorage(id) {
      let data = localStorage.getItem(id)
      try {
        data = JSON.parse(data)
        if (Object.keys(data).length > 0) {
          return data
        } else {
          return false
        }
      } catch (error) { return false }
    },

    // 切换视频
    toggle(val) {
      clearTimeout(this.autoNextTimer)
      const index = Number(this.course_info_index) + Number(val)
      const item = this.playData.course_info[index]
      if (item) {
        // 设置默认倍数
        this.multiplePlayClick(1,1)
        this.itemClick(item, index)
      }
    },

    studyTImeIntervalFun() {

    },
    //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
    playerReadied(player, playtimes) {

    },
    // 播放回调
    onPlayerPlay(player) {
      // // 计算总学习时长
      // if (this.play_type != 2) {
      //   this.timer = setInterval(() => {
      //     this.stayObj.study_time++
      //   }, 1000)
      // }
      // // 重置鼠标最后移动时间
      // this.mouseMoveLastTime = new Date().getTime()
      // this.playFlag = true
    },
    // 暂停回调
    onPlayerPause(player) {
      clearInterval(this.timer)
      this.playFlag = false
    },
    // 视频播完回调
    onPlayerEnded($event) {
      // 播放完成后上报
      this.pageStayReport()
      // 5s之后跳转下一集
      if (this.isShowNext) {
        this.$message.success('即将为您播放下一集')
        this.autoNextTimer = setTimeout(() => {
          this.toggle(Number(this.course_info_index) + 1)
        }, 3000)
      }
    },

    // DOM元素上的readyState更改导致播放停止
    onPlayerWaiting($event) { },

    //  已开始播放回调
    onPlayerPlaying($event) {
      this.playFlag = true
      // 不知道为什么在火狐浏览器中此处会被执行两次，定时器之类的操作不要放在这里
    },

    // 当播放器在当前播放位置下载数据时触发
    onPlayerLoadeddata($event) { },

    // 当前播放位置发生变化时触发。
    onPlayerTimeupdate(player) {
      // 获取当前播放时间
      const currentTime = Math.floor(player.cache_.currentTime)
      this.currentTimeNumber = currentTime
      this.calcprogressBar(currentTime)
    },

    // 重新计算进度条
    calcprogressBar(currentTime) {
      // 计算进度条，监听到正在拖拽的时候此处不对进度条进行处理
      if (!this.progressDrag) {
        this.currentTime = moment.utc(currentTime * 1000).format("HH:mm:ss")
        const w = this.currentTimeNumber / this.durationNumber
        this.styleObj.width = `${w * 100}%`
      }
    },

    //媒体的readyState为HAVE_FUTURE_DATA或更高
    onPlayerCanplay(player) {
      // 计算总时长
      this.durationNumber = Math.floor(player.cache_.duration)
      this.duration = moment.utc(this.durationNumber * 1000).format("HH:mm:ss")
      this.canClickControlBar = true
      // 静态修改观看状态
      if (this.play_type != 2) {
        this.playData.course_info[this.course_info_index].is_watch = true
      }
    },

    //媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
    onPlayerCanplaythrough(player) {
      // console.log('player Canplaythrough!', player)
    },

    //播放状态改变回调
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },

    playVideo() {
      this.$nextTick(() => {
        this.$refs.videoPlayer.player.currentTime(this.currentTimeNumber) // 设置播放时间
        this.$refs.videoPlayer.player.play()
      })
    },

    pauseVideo() {
      clearInterval(this.timer)
      this.playFlag = false
      this.$refs.videoPlayer.player.pause()
    },

    // 调解音量
    volumeClick() {
      let volume = 1
      if (this.volumeType == 1) {
        this.volumeType = 2
        volume = 0.3
      } else if (this.volumeType == 2) {
        this.volumeType = 3
        volume = 0
      } else {
        this.volumeType = 1
        volume = 1
      }
      this.$refs.videoPlayer.player.volume(volume)
    },

    // 倍数播放
    multiplePlayClick(el, index) {
      this.playbackRateShowFlag = false
      this.playbackRateIndex = index
      this.$refs.videoPlayer.player.playbackRate(el)
    },

    // 点击进度条
    barClick(e) {
      if (!this.canClickControlBar) return
      this.pauseVideo()
      this.progressChange(e, true)
    },

    // 进度条计算
    progressChange(e, isplay) {
      const p_w = this.$refs.progress.offsetWidth  // 获取进度条的宽度
      const click_w = e.pageX * 0.98  // 点击处的宽度；因为进度是宽度是屏幕的98%，所以在此处要乘以98%
      if (click_w > p_w || click_w < 0) return
      const w = click_w / p_w  // 获取占比
      this.styleObj.width = `${w * 100}%`  // 重新给进度条设置宽度
      this.currentTimeNumber = this.durationNumber * w  // 获取当前时间 单位是秒
      this.currentTime = moment.utc(Math.floor(this.currentTimeNumber) * 1000).format("HH:mm:ss")
      if (isplay) {
        this.playVideo() // 播放视频
      }
    },

    // 拖拽进度条
    ponitDown(e) {
      if (!this.canClickControlBar) return
      this.progressDrag = true
      this.pauseVideo()
      window.addEventListener('mousemove', this.handlerMove)
    },

    handlerMove(e) {
      this.progressChange(e)
    },

    // 拖拽进度条放开鼠标
    ponitUp(e) {
      if (!this.canClickControlBar) return
      if (this.progressDrag) {
        this.progressDrag = false
        window.removeEventListener('mousemove', this.handlerMove)
        this.playVideo()
      }
    },
    // 全屏操作
    screen() {
      this.$refs.videoPlayer.player.requestFullscreen()
    },
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  position: relative;
  background: #201F1F;
  overflow: hidden;

  .wrapper-left {
    // max-width: 1920px;
    min-width: 800px;

    .header {

      height: 82px;
      padding: 0 48px;
      box-sizing: border-box;
      background: #2d2b2b;
      // border: 1px solid #4D525F;

      .course-name {
        margin: 0 auto;
      }
    }

    .player-box {
      position: relative;
      z-index: 999;
      // background: #FFF;
      // height: calc(100vh - 82px);

      .video-player-wrapper {
        position: relative;

        .big-play {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 999;
          width: 146px;
          height: 146px;
          cursor: pointer;
        }

        .video-control-bar {
          user-select: none;
          width: 100%;
          height: 90px;
          background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.9));
          // border: 1px solid #4D525F;
          position: absolute;
          left: 0;
          bottom: 0;
          padding: 0 60px;
          box-sizing: border-box;

          .progress-box {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%);
            width: 98%;
            height: 6px;
            background: rgba(255, 255, 255, 0.3);
            border-radius: 100px;

            .trw {
              transition: width 0.3s;
              // transition-timing-function:linear;
            }

            .progress-green {
              position: absolute;
              top: 0;
              left: 0;
              max-width: 100%;
              height: 6px;
              background: #67C23A;


              .point {
                width: 10px;
                height: 10px;
                background: #FFFFFF;
                border-radius: 100px;
                position: absolute;
                top: -2px;
                right: -10px;
              }

              .point-big {
                width: 20px;
                top: -7px;
                height: 20px;
              }
            }
          }

          .icon {
            width: 28px;
            height: 28px;
            margin-right: 44px;
            cursor: pointer;
          }
        }
      }

      .fold-box {
        position: absolute;
        width: 24px;
        height: 52px;
        z-index: 999;
        top: 0;
        right: 0;
        background: rgba(51, 49, 49, 0.7);
        border-radius: 4px 0px 0px 4px;
      }
    }
  }

  .chapter-box {
    width: 404px;
    height: 100vh;
    // overflow: auto;
    background: #201F1F;
    position: absolute;
    top: 0;
    right: 0;
    padding: 17px 33px;
    box-sizing: border-box;

    .title {
      margin-top: 67px;
      margin-bottom: 55px;
      font-weight: 600;
    }

    .list {

      width: 100%;
      position: absolute;
      left: 0;
      overflow-x: hidden;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        width: 0 !important
      }

      .item {
        padding-bottom: 15px;
        // border-bottom: 1px solid #414141;
        display: flex;
        align-content: flex-start;
        justify-content: space-between;
        margin-bottom: 15px;
        cursor: pointer;

        &:hover {
          color: #2AB18B;
        }

        &:nth-last-child(1) {
          border: none;
        }

        .icon {
          width: 16px;
          height: 16px;
          margin-right: 10px;
        }
      }
    }
  }

}

.put-away {
  transition: width 0.35s;
  width: calc(100% - 404px);
}


.expand {
  width: 100%;
  transition: width 0.35s;
}

.chapter-hide {
  display: none;
  transition: width 0.35s;
}

.chapter-show {
  display: block;
  animation-duration: 0.3s !important;
}

.list-outer-container {
  position: relative;

  // border: 1px solid red;
  overflow: hidden;
}

.list,
.list-outer-container {
  height: 500px
}

/deep/ .video-player>div {
  padding-top: 844px !important;
  // padding-top: 56.3% !important;
}

/deep/ .vjs-big-play-button {
  display: none !important
}

/deep/ .vjs-control-bar {
  display: none;
  opacity: 0;
}

.icon-zanting {
  font-size: 22px;
}

.playbackRate-box {
  position: relative;
  // border: 1px solid red;

  .list {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    bottom: 25px;
    background: rgba(51, 49, 49, 0.7);
    width: 50px;
    height: 160px;

    .item {
      line-height: 40px;
      height: 40px;
      text-align: center;
    }


  }
}

.icon-w_shipin {
  font-size: 26px;
  margin-right: 10px;
  margin-top: 2px;
}

.icon-wancheng {
  font-size: 18px;
  margin-right: 10px;
  margin-top: 2px;
}

.color797878 {
  color: #797878;
}

.active {
  color: #2AB18B
}

.player-box-waiting {
  height: 855px;
  color: #FFF;
  font-size: 20px;
  background: #FFF;
}

.playing {
  width: 20px;
  margin-right: 10px;
}

.video_title {
  width: 180px;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
}
</style> 
<style>
#app {
  background: #201F1F
}
</style>